const uuid = require('uuid');
import React from 'react';
// import PropTypes from 'prop-types';

import { Handle, Position } from 'react-flow-renderer';

import AccessibleIcon from '../common/AccessibleIcon';
import ConfirmModal from '../modal/ConfirmModal';

const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');

class EditorCompletionNode extends React.Component {
    constructor(props) {
        super(props);
        let selectedNodeId = ShortCourseEditorStore.getState().selectedNodeId;
        this.state = {
            modalState: {},
            selected: (selectedNodeId == props.id)
        };
        this.unsubscribes = [ShortCourseEditorStore.listen(this.onStoreChange)];
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onStoreChange=(storeState)=>{
        let selectedNodeId = storeState.selectedNodeId;
        this.setState({
            selected: (selectedNodeId == this.props.id)
        });
    }

    setDeleteNodeModalState=(showBool)=>{
        this.setState({ modalState: { ...this.state.modalState, deleteNode: showBool } })
    }

    onDeleteNode=()=>{
        this.setDeleteNodeModalState(false);
        ShortCourseEditorActions.deleteSkillNode(uuid.v4(),this.props.id);
    }
    

    renderTargetHandles() {
        let handles = [];
        let n = Math.max(1,this.props.data.numTargetHandles || 1);
        let per_i = (100 / (n+1) );
        for (var i=0; i<n; ++i) {
            let id = `p${i+1}`;
            let pct = Math.round((i+1) * per_i);
            handles.push(
                // horizontally oriented graph: <Handle key={i} type="target" position={Position.Left} id={id} style={{ top: `${pct}%`, borderRadius: 0 }}/>
                <Handle key={i} type="target" position={Position.Top} id={id} style={{ left: `${pct}%`, borderRadius: 0 }}/>
            );
        }
        return handles;
    }
    

    render() {
        let imgElement;
        if (this.props.data.img_src) {
            imgElement = <img src={this.props.data.img_src}/>
        }
        return (
            <div className="course-node completion-node">
                <h1>{this.props.data.name}</h1>
                { this.props.data.description ? <h2>{this.props.data.description}</h2> : null }
                {this.state.selected ?
                <button className="delete-button" title="delete node" onClick={()=>{this.setDeleteNodeModalState(true)}}>
                    <AccessibleIcon className="fa fa-trash" label="delete node"/>
                </button>
                : null }
                {imgElement}
                <div className="content-overlay">
                    <div className="content">
                        <img src={`${GlobalConfig.StaticUrl}/img/courses/trophy.svg`}/>
                    </div>
                    {/*<Handle type="source" position={Position.Bottom} style={{ borderRadius: 0 }} /> */}
                </div>
                {this.renderTargetHandles()} 
                { this.state.modalState['deleteNode'] ? 
                <ConfirmModal show modalTitle="Delete Node"
                    text={`Are you sure you wish to delete ${this.props.data.name}`}
                    buttonText="Delete"
                    closeHandler={()=>{this.setDeleteNodeModalState(false)}}
                    confirmHandler={this.onDeleteNode} />
                : null }
                
            </div>
        );
    }
};

export default EditorCompletionNode;